<div class="tw-reset tw-relative tw-mx-4 tw-grid tw-h-dvh tw-place-items-center md:tw-mx-0">
  <div
    class="tw-absolute tw-top-14 tw-w-[488px] tw-rounded-2xl tw-bg-white tw-p-6 tw-pb-4 tw-shadow-xl"
    role="dialog"
  >
    <h4 class="tw-mb-4 tw-font-extrabold tw-text-neutral-800">
      {{ translate('Request Peer Rating', 'dgTagRating_RequestPeerRating') }}
    </h4>

    <dgx-user-search-v3
      [searchFn]="searchPeers"
      [ariaLabel]="
        translate('Search by name', 'recommendationForm_SearchByName')
      "
      [placeHolderLabel]="
        translate('Search by name', 'recommendationForm_SearchByName')
      "
      (onSelect)="onSelectItem($event)"
    ></dgx-user-search-v3>
    <!-- show selected peers when peers is selected -->
    @if (selectedPeers().length) {
      <div class="tw-mt-4 tw-flex tw-w-full tw-flex-col">
        @for (peer of selectedPeers(); track peer) {
          <dgx-user-search-item-v3
            [item]="peer"
            [isRemovable]="true"
            (onRemove)="onRemoveItem(peer)"
          ></dgx-user-search-item-v3>
        }
      </div>
    }
    @if (showPeerCountWarning()) {
      <da-alert
        [config]="{
          title: translate(
            'You are about to send a Peer Rating request to more than 20 people.',
            'dgTagRating_PeerRequestCountWarning',
            { count: maxPeerCount }
          ),
        }"
        theme="warning"
      ></da-alert>
    }
    <div class="tw-flex tw-flex-grow tw-py-8" [formGroup]="comments">
      <da-textarea
        size="normal"
        class="tw-flex-grow tw-pt-5"
        inputId="comment"
        formControlName="comment"
        [maxLength]="commentMaxLength"
        [labelText]="
          translate(
            'Add an optional message to your request',
            'Core_OptionalMessage_Request'
          )
        "
        [helperText]="translate('Optional', 'Core_Optional')"
        data-dgat="tag-peer-request-rating-comment-28e"
        ngDefaultControl
      />
    </div>
    <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
      <div class="tw-flex-1">
        <label
          id="cancelPendingRequest-label"
          class="tw-text-sm tw-font-semibold tw-text-neutral-800"
          >{{
            translate(
              'Cancel Pending Peer Rating Requests',
              'dgTagRating_CancelPeerRequests'
            )
          }}
        </label>
        <p class="tw-text-xs tw-font-normal tw-text-neutral-800">
          {{
            translate(
              'If anyone in your list has a pending Peer Rating request from you for this skill, select this to cancel that request and send a new one.',
              'dgTagRating_CancelPeerRequestsDesc'
            )
          }}
        </p>
      </div>
      <!-- TODO: As of now apollo switch component not available using html and tailwind to create Switch, 
       once Apollo component available need to replace this-->
      <label class="tw-inline-flex tw-cursor-pointer tw-items-center"
        ><input
          type="checkbox"
          [checked]="cancelRequests()"
          tabindex="-1"
          (change)="togglePermission()"
          class="tw-peer tw-sr-only"
          data-dgat="tag-peer-request-rating-check-2fe"
          id="cancelPendingRequest" />
        <div
          tabindex="0"
          role="checkbox"
          class="tw-relative tw-h-5 tw-w-10 tw-rounded-full tw-bg-neutral-300 tw-py-0.5 tw-pr-0.5 after:tw-absolute after:tw-start-0.5 after:tw-top-0.5 after:tw-h-4 after:tw-w-4 after:tw-rounded-full after:tw-border after:tw-border-white after:tw-bg-white after:tw-transition-all after:tw-content-[''] peer-checked:tw-bg-blue-800 peer-checked:after:tw-start-1.5 peer-checked:after:tw-translate-x-full peer-checked:after:tw-border-white rtl:peer-checked:after:-tw-translate-x-full dark:tw-border-blue-800 dark:tw-bg-blue-800"
          [attr.aria-checked]="cancelRequests()"
          aria-describedby="cancelPendingRequest-label"
          aria-labelledby="cancelPendingRequest"
        ></div
      ></label>
    </div>
    <div class="tw-flex tw-w-full tw-justify-end tw-gap-4 tw-pt-6">
      <button
        type="button"
        class="tw-btn-medium tw-btn-secondary-filled"
        data-dgat="tag-peer-cancel-rating-57f"
        [attr.aria-label]="translate('Cancel', 'Core_Cancel')"
        (click)="cancel()"
      >
        {{ translate('Cancel', 'Core_Cancel') }}
      </button>
      <button
        type="button"
        class="tw-btn-primary tw-btn-medium"
        data-dgat="tag-peer-request-rating-57e"
        [attr.aria-label]="
          translate('Send Request', 'RequestRating_SendRequest')
        "
        [disabled]="!selectedPeers().length || isRequestProcessing()"
        (click)="submit()"
      >
        {{ translate('Send Request', 'RequestRating_SendRequest') }}
      </button>
    </div>
  </div>
</div>
